import React from 'react';
import * as Styles from './LogoBuilder.styles';
import { Button, IconButton } from 'gatorcomponents';
import SnappyPainter from './snappyPainter';
import { useResize } from '@/hooks/useResize';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import { logoBuilderAnalytics } from '@/analytics/logoBuilder';

const LogoBuilder = ({ handleLogoBuilderBanner }) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;

  const history = useHistory();

  const { routes: routesLocale, sites: sitesLocale } = useLocale();

  const redirectToLogoBuilder = () => {
    history.push(routesLocale.logoBuilder);
    logoBuilderAnalytics.bannerClick();
  };

  const handleClose = () => {
    handleLogoBuilderBanner();
    logoBuilderAnalytics.bannerClose();
  };

  return (
    <Styles.CardWrapper>
      <Styles.SvgWrapper>
        <SnappyPainter mobile={mobile} />
      </Styles.SvgWrapper>

      <Styles.DivText>
        <Styles.Title data-testid="title">
          {sitesLocale.infosLogoBuilder.title}

        </Styles.Title>

        <Styles.Span>Beta</Styles.Span>

        <Styles.Description data-testid="description">
          {sitesLocale.infosLogoBuilder.description}
        </Styles.Description>
      </Styles.DivText>

      <Styles.ButtonWrapper>
        <Button
          testId="cta"
          label={sitesLocale.infosLogoBuilder.buttonCta}
          variant="primary"
          size={mobile ? 'small' : 'medium'}
          onClick={redirectToLogoBuilder}
        />
      </Styles.ButtonWrapper>

      <Styles.CloseButton data-testid="logo-builder-banner-close">
        <IconButton icon="IconClose" onClick={handleClose} />
      </Styles.CloseButton>

      <Styles.GradientBar />
    </Styles.CardWrapper>
  );
};

export default LogoBuilder;
